import EformBaseService from "../../../services/EformBaseService";

export default class NachtragService extends EformBaseService {

  constructor() {
    super('wbf/nachtrag')
  }
}
